import { render } from "./TopCategoriesTableCard.vue?vue&type=template&id=0829f95d"
import script from "./TopCategoriesTableCard.vue?vue&type=script&lang=js"
export * from "./TopCategoriesTableCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TopCategoriesTableCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0829f95d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0829f95d', __exports__)) {
    api.reload('0829f95d', __exports__)
  }
  
  module.hot.accept("./TopCategoriesTableCard.vue?vue&type=template&id=0829f95d", () => {
    api.rerender('0829f95d', render)
  })

}


export default __exports__